export default class {

    constructor() {}

    formatCurrency(currency){
        currency =  Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN'}).format(currency);
        currency =  currency.replace("₦","") //if sign showing as in Edge browser
        currency =  currency.replace("NGN",""); //strip off NGN
        // return currency;
        currency = currency.replace(".00","");
        return (currency.replace(/\s/g, '')); //remove space
    }

}


// WEBPACK FOOTER //
// ./src/services/commons.js